export default "__VITE_ASSET__Cx2X4Hhq__"